module.exports = __webpack_public_path__ + "static/img/numberraise1.7e64ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/numberraise1.png
// module id = 0fm2
// module chunks = 1